import { useTranslate } from '@tolgee/react';
import useCrud from 'hooks/useCrud';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getProblemList } from './service';
import { message } from 'antd';
import ProblemTable from './ProblemTable';

function NormalTableContent({
  isVoice,
  isAdvantage,
  filter,
  newProblemOnly,
  problemCategoryId,
}: {
  isVoice?: boolean;
  isAdvantage?: boolean;
  filter: ReviewAnalysis.OverviewFilter;
  newProblemOnly: boolean;
  problemCategoryId: number;
}) {
  const { t } = useTranslate();

  const [sortOrder, setSortOrder] = useState<'DESC' | 'ASC'>('DESC');

  const { loading, item, setItem, fetch } = useCrud({
    read: useCallback((body: Parameters<typeof getProblemList>[0]) => getProblemList(body), []),
  });

  const refsCurrent = {
    t,
    fetch,
    setItem,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    return () => refs.current.setItem(undefined);
  }, [problemCategoryId]);

  useEffect(() => {
    refs.current
      .fetch({
        onlyNewProblem: newProblemOnly,
        problemCategoryId,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        overviewRequest: {
          ...filter,
          stars: isVoice ? filter.stars : filter.stars.length ? filter.stars : [1, 2, 3],
        },
        sortOrder,
        sentimentType: isAdvantage ? 1 : 2,
      })
      .catch(() => {
        message.error(refs.current.t('phrase.获取数据失败，请稍后再试'));
      });
  }, [filter, sortOrder, newProblemOnly, problemCategoryId, isVoice, isAdvantage]);

  const { pageInfo, problemList } = item || {};

  return (
    <ProblemTable
      loading={loading}
      dataSource={problemList}
      pagination={
        pageInfo
          ? {
              size: 'small',
              showSizeChanger: true,
              showQuickJumper: true,
              current: pageInfo.page,
              pageSize: pageInfo.pageSize,
              total: pageInfo.totalCount,
              onChange: (page, pageSize) =>
                fetch({
                  onlyNewProblem: newProblemOnly,
                  problemCategoryId,
                  pageInfo: {
                    page,
                    pageSize,
                  },
                  overviewRequest: {
                    ...filter,
                    stars: isVoice ? filter.stars : filter.stars.length ? filter.stars : [1, 2, 3],
                  },
                  sortOrder,
                }).catch(() => {
                  message.error(t('phrase.获取数据失败，请稍后再试'));
                }),
            }
          : false
      }
      onChange={(_, __, ___, { action }) => {
        if (action === 'sort') {
          setSortOrder(sortOrder === 'ASC' ? 'DESC' : 'ASC');
        }
      }}
      isVoice={isVoice}
      isAdvantage={isAdvantage}
      isLogistics={problemCategoryId === 2}
      sortOrder={sortOrder}
      onUpdate={(list) =>
        item &&
        setItem({
          ...item,
          problemList: list,
        })
      }
    />
  );
}

export default NormalTableContent;
